import React from 'react';

class RadioAnswers extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    let questionData = this.props.questionData;
    if (this.props.onChange) this.props.onChange(e.target.value, questionData, "answer_id");
  }

  render() {
    let { questionData } = this.props;
    return(
      <div>
        {questionData.answers.map((answer) => {
          return(
            <div key={`answer-${answer.id}`}>
              <label className='survey-answer-label'>
                <input
                  onChange={this.handleChange}
                  type="radio"
                  checked={(this.props.value == answer.id)}
                  disabled={this.props.disabled}
                  value={answer.id}
                  className="mr1"
                />
                {answer.answer}
              </label>
            </div>
          )
        })}
      </div>
    )
  }
}

export default RadioAnswers;
